<div class="auth-page">
  <div class="auth-card">
    <div class="auth-header">
      <img alt="Logo" class="auth-logo" src="assets/logo.png" routerLink="/dashboard">
      <h2 class="auth-title">{{ 'verify_email.verifying' | translate }}</h2>
    </div>
    <div class="auth-body text-center">
      <!-- Success -->
      <div *ngIf="resultReady && isSuccess" class="py-4">
        <div class="success-icon mb-4">
          <i class="bi bi-check-circle fs-1 text-success"></i>
        </div>
        <h4 class="text-success mb-3">{{ 'verify_email.success_title' | translate }}</h4>
        <p class="text-muted mb-4">{{ 'verify_email.success_text' | translate }}</p>
        <button class="btn btn-primary btn-lg" (click)="goToLogin()">
          <i class="bi bi-box-arrow-in-right me-2"></i>{{ 'verify_email.go_to_login' | translate }}
        </button>
      </div>

      <!-- Error -->
      <div *ngIf="resultReady && !isSuccess" class="py-4">
        <div class="error-icon mb-4">
          <i class="bi bi-x-circle fs-1 text-danger"></i>
        </div>
        <h4 class="text-danger mb-3">{{ 'verify_email.fail_title' | translate }}</h4>
        <p class="text-muted mb-4">{{ errorMessage || ('verify_email.fail_text' | translate) }}</p>
        <div class="d-flex justify-content-center gap-3">
          <button class="btn btn-outline-primary" routerLink="/register">
            <i class="bi bi-person-plus me-2"></i>{{ 'register.submit' | translate }}
          </button>
          <button class="btn btn-primary" (click)="goToLogin()">
            <i class="bi bi-box-arrow-in-right me-2"></i>{{ 'verify_email.go_to_login' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
